// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import ModalController from "./modal_controller";
import NavDropdownController from "./nav_dropdown_controller";
import FileUploadController from "./file_upload_controller";
import HighlightNewRecordController from "./highlight_new_record_controller";
import FormSubmissionController from "./form_submission_controller";
import ElementRemovalController from "./element_removal_controller";
import ListPanelController from "./list_panel_controller";
import SearchFieldController from "./search_field_controller";
import MobileMenuController from "./mobile_menu_controller";
import LandRegistrationController from "./land_registration_controller";
import DatePickerController from "./date_picker_controller";
import AccessibleChartController from "./accessible_chart_controller";
import DestructiveConfirmationController from "./destructive_confirmation_controller";
import DirectorFormController from "./director_form_controller";
import FileSelectionController from "./file_selection_controller";
import InlineConfirmController from "./inline_confirm_controller";
import InlineFormController from "./inline_form_controller";
import InteractionStatesController from "./interaction_states_controller";
import ListFiltersController from "./list_filters_controller";
import ListStateController from "./list_state_controller";
import OwnerStepController from "./owner_step_controller";
import UnsavedChangesController from "./unsaved_changes_controller";

application.register("nav-dropdown", NavDropdownController);
application.register("modal", ModalController);
application.register("file-upload", FileUploadController);
application.register("highlight-new-record", HighlightNewRecordController);
application.register("form-submission", FormSubmissionController);
application.register("element-removal", ElementRemovalController);
application.register("list-panel", ListPanelController);
application.register("search-field", SearchFieldController);
application.register("mobile-menu", MobileMenuController);
application.register("land-registration", LandRegistrationController);
application.register("date-picker", DatePickerController);
application.register("accessible-chart", AccessibleChartController);
application.register("destructive-confirmation", DestructiveConfirmationController);
application.register("director-form", DirectorFormController);
application.register("file-selection", FileSelectionController);
application.register("inline-confirm", InlineConfirmController);
application.register("inline-form", InlineFormController);
application.register("interaction-states", InteractionStatesController);
application.register("list-filters", ListFiltersController);
application.register("list-state", ListStateController);
application.register("owner-step", OwnerStepController);
application.register("unsaved-changes", UnsavedChangesController);
